import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const JetskiIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 216"
      style={{ enableBackground: 'new 0 0 360 216' }}
    >
      <defs>
        <linearGradient
          id="SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="216"
          x2="0.7071"
          y2="215.2929"
        >
          <stop offset="0" style={{ stopColor: '#20AC4B' }} />
          <stop offset="0.9831" style={{ stopColor: '#19361A' }} />
        </linearGradient>
      </defs>
      <style type="text/css">
        {`
        .Arched_x0020_Green { fill: currentColor; stroke: currentColor; stroke-width: 0.25; stroke-miterlimit: 1; }
        .st0 { fill: currentColor; }
      `}
      </style>
      <path
        className="st0"
        d="M325.6,110l-25.7-20l-54-45.5c-2.2-1.9-5.5-2-7.8-0.2l-4.3,3.2l-30.7-18.3c-2-1.2-4.6-1.2-6.6,0.1
	c-2,1.3-3.1,3.6-2.9,5.9l1.8,17.9l-8.1-0.2c-3.5-0.1-6.4,2.7-6.4,6.2c-0.1,3.5,2.7,6.4,6.2,6.4l11.8,0.3c0.2,0.2,0.4,0.3,0.7,0.4
	l4.9,2.6l-8.1,2.1c0,0-0.1,0-0.1,0c-0.2,0.1-0.4,0.1-0.5,0.2c0,0-0.1,0-0.1,0c-1.1,0.5-2.2,1.2-2.9,2.4c-0.2,0.4-0.4,0.7-0.6,1.1
	c-0.3,0.8-5.6,12.5-19.2,13.4c-11.5,0.7-21.5-9.8-21.6-9.9c-0.9-1-2.1-1.6-3.4-1.9l-48.7-9.6c-3.3-0.6-6.5,1.4-7.3,4.6L89.3,81
	l-15.9-2.3c-2.6-0.4-5.2,0.9-6.4,3.2l-6.5,11.9c-1.7,3.1-0.6,6.9,2.5,8.6l15.3,8.4c-1.8,1.2-3.8,2.4-5.7,3.3
	c-7,3.3-32.5,15.1-32.8,15.3c-2.2,1-3.7,3.3-3.7,5.7v33.7c0,3.5,2.8,6.3,6.3,6.3h200.8c0.6,0,1.8,0.1,3.6,0.1
	c5.5,0,16.5-0.8,30.5-5.6c22.8-7.8,34.3-22.1,36.4-24.8c3.6-4.9,12.1-23.6,13.7-27.3C328.6,114.9,327.9,111.8,325.6,110z M231,60.3
	c2.2,1.3,4.9,1.2,7-0.4l3.6-2.7l41.9,35.3l-45.9,3.5c-0.3-0.3-0.6-0.6-1-0.8L213,79.5l10-2.7c2.5-0.7,4.3-2.8,4.6-5.4
	c0.3-2.6-1-5.1-3.3-6.3l-16-8.6l-1-10.3L231,60.3z M303.6,137.2c-1,1.4-10.7,13.7-30.4,20.5c-17.2,5.9-28.9,4.8-29,4.8
	c-0.2,0-0.5,0-0.7,0H48.7v-21c7.1,0.4,36.3,2.1,67.7,2.1c9,0,18.2-0.1,27.1-0.5c45.6-1.7,63.3-2.6,78.1-4.3
	c15-1.7,60.6-8.8,62.6-9.1c3.4-0.5,5.8-3.8,5.3-7.2c-0.5-3.4-3.8-5.8-7.2-5.3c-0.5,0.1-47.4,7.4-62.1,9c-14.4,1.6-31.9,2.5-77.2,4.2
	c-26.4,1-55.4,0.2-74.4-0.6c3.9-1.8,7.4-3.4,9.4-4.4c7.8-3.7,15.6-10.6,15.9-10.9c1.5-1.4,2.3-3.4,2.1-5.4s-1.4-3.8-3.2-4.8
	l-18.3-10l1.4-2.5L93,94.3c0.1,0,0.3,0,0.4,0c3.7,2.8,9.1,6.7,13.2,8.7c6.4,3.2,11.6,5.3,11.9,5.3c0.8,0.3,1.5,0.4,2.3,0.4
	c2.5,0,4.9-1.5,5.9-4c1.3-3.2-0.3-6.9-3.6-8.2c0,0-4.9-1.9-10.8-4.9c-3-1.5-7.5-4.7-11-7.3l1.1-4.4l41,8.1
	c4.1,3.8,15.7,13.3,30.1,12.4c13.8-0.9,22-8.7,26.3-14.6l19.8,13.3c-13.5,2.5-33,5.8-44.7,6.6c-18.4,1.3-35.2-3.7-35.4-3.7
	c-3.3-1-6.8,0.9-7.8,4.2c-1,3.3,0.9,6.8,4.2,7.9c0.7,0.2,15.1,4.5,32.7,4.5c2.4,0,4.8-0.1,7.3-0.3c19.2-1.4,56.6-8.8,61-9.7
	l58.8-4.5c0.5,0,1-0.1,1.5-0.3l8,6.2l-7.2,2.5c-3.3,1.2-5,4.8-3.8,8c0.9,2.6,3.3,4.2,5.9,4.2c0.7,0,1.4-0.1,2.1-0.4l9.6-3.4
	C308.6,128.2,305.1,135.3,303.6,137.2z"
      />
    </svg>
  </StyledSvgIcon>
);
export default JetskiIcon;

JetskiIcon.propTypes = customIconsPropTypes;
